import {
  SHOW_ERROR_SCREEN
} from 'constants/ActionTypes';

export const ShowErrorScreen = () => {
  return {
    type: SHOW_ERROR_SCREEN
  };
};